import React from 'react'
import { NextSeo } from 'next-seo'
import LegalTemplate from '@/src/components/Legal/LegalTemplate'
import LegalFDA from 'src/components/Legal/LegalFDAWaiver.js'


const FDA = () => {
  return (
    <>
      <LegalFDA  />
      <NextSeo title='FDA waiver | Orka - Hear what matters' />
    </>
  )
}

export default FDA
